import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DevicePhotoService } from 'src/app/components/devices-components/device-photo-gallery-card/device-photo.service';

@Component({
  selector: 'app-device-photo-zoom-dialog',
  templateUrl: './device-photo-zoom-dialog.component.html',
  styleUrls: ['./device-photo-zoom-dialog.component.scss']
})
export class DevicePhotoZoomDialogComponent implements OnInit {

  photoURL: string;

  constructor(public dialogRef: MatDialogRef<DevicePhotoZoomDialogComponent>,
              private devicePhotoService: DevicePhotoService ) { }

  ngOnInit() {
    this.devicePhotoService.getPhotoURL().subscribe(
      (result) => {
        this.photoURL = result;
      }
    );
  }

}
